import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CharactersSection from "./components/CharactersSection";
import BooksSection from "./components/BooksSection";
import LessonsSection from "./components/LessonsSection";
import ReviewsSection from "./components/ReviewsSection";
import AuthorSection from "./components/AuthorSection";
import CtaSection from "./components/CtaSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body overflow-x-hidden">
      <Navbar />
      <main>
        <HeroSection />
        <CharactersSection />
        <BooksSection />
        <LessonsSection />
        <ReviewsSection />
        <AuthorSection />
        <CtaSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}